import ReactDOM from 'react-dom';
import ReactTooltip from 'react-tooltip';
import getPosition from '../zoom_temp';
import { useClient } from '../../common/utils/windowDimensions';
import { useEffect, useMemo, useState } from 'react';
import { useIsTouchDevice } from '../../common/utils/utils';
const project = require('../../scripts/configs/project');

/* TODO ZOOM */
export const overridePosition = (prevPosition, currentEvent, currentTarget, node, desiredPlace, _, effect, offset) => {
    var result = getPosition(currentEvent, currentTarget, node, desiredPlace.split(',')[0], desiredPlace, effect, offset);

    return result.position || prevPosition;
};
/* TODO ZOOM */
export const useTooltip = (params) => {
    const { tooltipId, text, place, setIsShowed, disableOnMobile } = params || {};
    const [id, setId] = useState(tooltipId || false);
    const client = useClient();
    const isTouch = useIsTouchDevice();

    useEffect(() => {
        if (!tooltipId) {
            setId(`${Math.floor(Math.random() * 10000000)}tooltip`);
        }
    }, [tooltipId]);

    const tooltipAttributes = useMemo(() => {
        let attributes = {
            id,
            effect: 'solid',
            delayHide: 100,
            /* TODO ZOOM */
            overridePosition: project.zooming && overridePosition,
            /* TODO ZOOM */
            clickable: true,
            globalEventOff: isTouch ? 'click' : undefined
        };
        if (place) {
            attributes['place'] = place;
        }
        return attributes;
    }, [id, isTouch, place]);

    if (!text) {
        return { id, attributes: {} };
    }

    return {
        id,
        attributes: {
            'data-tooltip-id': id,
            'data-tooltip-content': text,
            'data-for': id,
            'data-tip': id,
            'data-text-color': 'var(--whiteColor)',
            'data-class': 'react-tooltip',
            'data-multiline': true,
            ...(isTouch && !disableOnMobile ? { 'data-event': 'click focus' } : {})
        },
        tooltipAttributes,
        simpleTooltip:
            text && client
                ? ReactDOM.createPortal(
                      <ReactTooltip
                          afterShow={() => {
                              setIsShowed && setIsShowed(true);
                          }}
                          afterHide={() => setIsShowed && setIsShowed(false)}
                          {...tooltipAttributes}
                      >
                          <div>{text}</div>
                      </ReactTooltip>,
                      document.body
                  )
                : null
    };
};
